import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Living life in 25min increments",
  "description": "",
  "published": "2011-06-21T00:00:00.000Z",
  "redirect_from": ["/blog/living-life-in-25min-increments/swizec/1859"],
  "categories": "Getting Things Done, Klout, Pomodoro Technique, Time management, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The past couple of weeks I've been living my life at 25 minute increments.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/300px-Il_pomodoro.jpg",
        "alt": "Pomodoro Timer",
        "title": "Pomodoro Timer"
      }}></img></p>
    <p>{`It's a new `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Productivity",
        "title": "Productivity"
      }}>{`productivity`}</a>{` hack I've been trying out ... you've probably heard of it - pomodoro? The idea is that you should make an effort for absolute focus when you're working. That means no twitter, no browsing random websites, just take a task, focus on it 100% and plow right through until you're done.`}</p>
    <p>{`Obviously you can't do this for 8 hours a day unless you're some sort of robot. Most people aren't robots. Yet.`}</p>
    <p><em parentName="p">{`tl;dr --> Pomodoro is great for productivity, bad for Klout scores`}</em></p>
    <p>{`Therefore pomodoro demands that you take a short break every 25 minutes, and a longer one every two hours. Apparently this is just enough to keep your brain fresh for plowing through tasks like a boss and `}<em parentName="p">{`getting shit done`}</em>{`.`}</p>
    <p>{`I have to say I was a bit skeptical of the whole premise. I can't work like that! I have a scatterbrain's mind. My mind thinks in parallels rather than linearly. The internet has ruined my ability to focus! I don't have 25 minutes of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Attention_span",
        "title": "Attention span"
      }}>{`attention span`}</a>{`, are you fucking kidding me?`}</p>
    <p>{`But then I got busy. Workloads started piling up and my scattered approach just wasn't working anymore. Even though it tends to work pretty well when you only have a project or two going on, it tended to fall apart when I had five projects I was working on in parallel. Thoughts started overflowing and my mind was just overloaded.`}</p>
    {
      /*more*/
    }
    <p>{`So I started trying out setting limits for myself. Rather than saying "I will work on this until it gets done, then I will work on that other thing" I just set up timeslots. Two hours for this, then no matter whether it's done or not, the other thing for two hours.`}</p>
    <p>{`And so on ad infinitum.`}</p>
    <p>{`It worked pretty well, but I could notice myself getting burned out. Holding sufficient levels of focus for two hours is `}<em parentName="p">{`hard`}</em>{`. Then I remembered this so called `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pomodoro_Technique",
        "title": "Pomodoro Technique"
      }}>{`Pomodoro`}</a>{` technique @gandalfar mentioned in passing one day. It seemed an awful lot like what I was doing was some sort of pomodoro anyway.`}</p>
    <p>{`Next step was to download a loud ticking pomodoro clock for my iPhone and start trying it out.`}</p>
    <p>{`It felt weird as hell!`}</p>
    <p>{`But I noticed a couple of things:`}</p>
    <ol>
      <li parentName="ol">{`The loud ticking acts as a milfy hot angry grade school teacher, tapping her ruler and looking at you going "Get to work maggot! Stop staring at my rack! WORK!"`}</li>
      <li parentName="ol">{`Taking short breaks when you're in the flow is surprisingly hard`}</li>
      <li parentName="ol">{`The scheduled long breaks are pure `}<em parentName="li">{`awesome`}</em></li>
      <li parentName="ol">{`Forcing yourself to take a break pays dividends at 2am when you're still fresh as a rose and able to focus`}</li>
    </ol>
    <p>{`At this point I would like to admit that I sometimes don't follow the ticking tomato as rigorously as I should. I often skip the short break because I'm on the verge of getting something done, and sometimes I take a break a couple of minutes early because I had just plowed through two pomodoro's without taking a break. Also, the last pomodoro in a batch is usually starting to get a bit haywire and isn't absolutely focused.`}</p>
    <p>{`However, despite all my flaws in following the technique, the past couple of weeks have been particularly good to me productivity-wise.`}</p>
    <p>{`I have:`}</p>
    <ul>
      <li parentName="ul">{`finished two pretty large school projects with fantastic grades`}</li>
      <li parentName="ul">{`passed several exams with decent enough grades`}</li>
      <li parentName="ul">{`started and launched `}<a parentName="li" {...{
          "href": "http://githubfriends.swizec.com"
        }}>{`GithubFriends`}</a></li>
      <li parentName="ul">{`watched 132 episodes of How I Met Your Mother`}</li>
      <li parentName="ul">{`had the most fruitful freelancing month ever`}</li>
      <li parentName="ul">{`had an actual social life all throughout`}</li>
    </ul>
    <p>{`Although, all the focus during pomodoros has had one very awful side-effect. My Klout score is experiencing massive drops:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/jLW0g4.png",
        "alt": null,
        "title": "Fluctuating like a boss"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://linearfix.wordpress.com/2011/04/07/pomodoro-technique-improves-focus-with-a-timer/"
        }}>{`Pomodoro Technique Improves Focus with a Timer`}</a>{` (linearfix.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://alecthegeek.wordpress.com/category/work-practices/"
        }}>{`Work Practices " Alec the Geek`}</a>{` (alecthegeek.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gigaom.com/collaboration/the-pomodoro-technique-another-option-for-getting-things-done-and-staying-focused/"
        }}>{`The Pomodoro Technique: A GTD Alternative?: Online Collaboration "`}</a>{` (gigaom.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sse4m.wordpress.com/2011/05/14/the-pomodoro-technique/"
        }}>{`The Pomodoro Technique!`}</a>{` (sse4m.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=8c8eee0a-b959-4bcd-abd3-4a3f2cd9b336",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      